import { render, staticRenderFns } from "./UserHistoryAddRestrictedList.vue?vue&type=template&id=0f708bb2&"
import script from "@/scripts/modal/userHistoryAddRestrictedList.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/userHistoryAddRestrictedList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports